/**
* 
* isdCheckBox
*/
import React from "react";
import { observer } from "mobx-react";
import stateStore from "../../store/stateStore";
const IsdCheckBox = observer((props) => {

    //onChangeイベント(入力変更時に実行されるイベント)
    const handleCheckboxClick = (event) => {
        // チェック状態を更新
        if (!props.dataGrid) stateStore.setState(props.name, !stateStore.state[props.name]);
        if (props.onChange) props.onChange(event);
    };

    return (
        <>
            <input
                disabled={props.disabled ? 'disabled' : ''}
                type="checkbox"
                checked={props.checked ? props.checked : false}
                id={props.id}
                name={props.name}
                onChange={handleCheckboxClick}
            />
        </>
    );
})

export default IsdCheckBox;
